import { AxiosError } from 'axios';
import { useState } from 'react';
import toast from 'react-hot-toast';
import { MonthlyFeedbackDataType } from '../../models/feedback/feedback.model';
import {
  ErrorHttpResponse,
  HttpConfig,
  SuccessHttpResponse,
} from '../../models/https';

import useHttps from '../useHttps';

const useSubmitMonthlyFeedback = () => {
  const request = useHttps();
  const [loading, setLoading] = useState(false);

  const onSubmitMonthlyFeedbackError = (err: AxiosError<ErrorHttpResponse>) => {
    toast.error(
      err?.response?.data?.message ??
        'Something went wrong while sending feedback'
    );
  };

  const onSubmitMonthlyFeedbackSuccess = ({
    data,
    message,
  }: SuccessHttpResponse<any>) => {
    toast.success(`${message}, thank you for your feedback!`);
  };

  const submitMonthlyFeedback = async (data: MonthlyFeedbackDataType) => {
    sessionStorage.setItem('SMFP', 'false');
    sessionStorage.setItem('SIFP', 'false');

    const config: HttpConfig = {
      url: 'auth-service/feedback/monthly',
      method: 'post',
      data,
      headers: {
        'Content-Type': 'application/json',
      },
    };

    request(
      config,
      onSubmitMonthlyFeedbackSuccess,
      setLoading,
      onSubmitMonthlyFeedbackError
    );
  };

  return { submitMonthlyFeedback, loading };
};

export default useSubmitMonthlyFeedback;
